import React from 'react';

import './PublicDocument.css';
import PublicShell from './PublicShell';

export function Imprint() {
    return (
        <PublicShell document>
            <article className="public-document" aria-labelledby="imprint-title">
                <header className="public-document__header">
                    <p className="public-document__eyebrow">Legal information</p>
                    <h1 id="imprint-title">Imprint</h1>
                    <p className="public-document__intro">
                        Provider and responsibility information for the Progress Lands web service.
                    </p>
                </header>

                <section className="public-document__section">
                    <h2>Service information</h2>
                    <dl className="public-document__meta">
                        <dt>Service</dt>
                        <dd>Progress Lands</dd>
                        <dt>Format</dt>
                        <dd>Browser-based asynchronous survival role-playing game</dd>
                        <dt>Website</dt>
                        <dd>{window.location.origin}</dd>
                    </dl>
                </section>

                <section className="public-document__section">
                    <h2>Operator and contact</h2>
                    <p className="public-document__notice">
                        Legal operator, postal address, and direct contact details have not yet
                        been configured for this deployment.
                    </p>
                    <p>
                        These details must be completed before a public production launch.
                    </p>
                </section>

                <section className="public-document__section">
                    <h2>Content responsibility</h2>
                    <p>
                        The operator identified above is responsible for the content of this service.
                        External links remain the responsibility of their respective providers.
                    </p>
                </section>
            </article>
        </PublicShell>
    );
}
